import { UiToast } from 'components';
import { observer } from 'mobx-react';
import styled, { keyframes } from 'styled-components';

import service from './service';

const aniUp = keyframes`
  from{
    transform: translateY(100%);
  }
  to{
    transform: translateY(0%);
  }

`;

const Wrap = styled.div`
  position: fixed;
  left: 12px;
  bottom: 24px;
  background: url(${require('./images/bg.png')}) 0 0 / contain no-repeat;
  width: 373px;
  height: 435px;
  box-sizing: border-box;
  padding: 36px 28px 0;
  color: #1a1a1c;
  z-index: 3000;
  animation: ${aniUp} 0.4s ease-in-out forwards;

  &.answered {
    background: url(${require('./images/bg-ok.png')}) 0 0 / contain no-repeat;
    width: 373px;
    height: 385px;
    .action {
      display: none;
    }
  }

  .hd {
    padding-left: 62px;
    box-sizing: border-box;
    padding-top: 4px;
    height: 52px;
    position: relative;

    &__avatar {
      position: absolute;
      left: 0;
      top: 0;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 1px solid #ffffff;

      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        vertical-align: top;
      }
    }

    .text-overflow {
      max-width: 8em;
      font-size: 16px;
      font-weight: 600;
    }

    &__time {
      color: #515151;
      font-size: 12px;
    }
  }

  .content {
    font-size: 24px;
    font-weight: 600;
    height: 200px;
    margin-top: 45px;
    //background-color: rgba(255, 147, 162, 0.59);
    display: flex;
    padding: 0 20px;
    align-items: center;
  }

  .action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 65px 0;
  }

  .btn-cancel {
    background: url(${require('./images/btn-cancel.png')}) 0 0 / contain no-repeat;
    width: 80px;
    height: 80px;
    cursor: pointer;
  }

  .btn-ok {
    background: url(${require('./images/btn-ok.png')}) 0 0 / contain no-repeat;
    width: 80px;
    height: 80px;
    cursor: pointer;
  }

  .status {
    &--ok {
      position: absolute;
      right: 24px;
      top: 90px;
      background: url(${require('./images/status-ok.png')}) 0 0 / contain no-repeat;
      width: 87px;
      height: 57px;
    }

    &--waiting {
      position: absolute;
      right: 24px;
      top: 90px;
      background: url(${require('./images/status-waiting.png')}) 0 0 / contain no-repeat;
      width: 87px;
      height: 57px;
    }
  }
`;

const PopupWish = observer((props) => {
  const { data, index, onClose } = props;

  const handleAccept = () => {
    service.acceptUserWish(data.id);
    onClose();
  };

  const handleCancel = () => {
    UiToast.text('已成功拒绝！');
    onClose();
  };

  return (
    <Wrap style={{ zIndex: index }}>
      <div className="hd">
        <div className="hd__avatar">
          <img src={data.pic} alt="" />
        </div>
        <div className="hd__nickname">
          <span className="text-overflow">{data.nickname}</span>
        </div>
        <div className="hd__time">1分钟前 发起了心愿</div>
      </div>
      <div className="content">{data.content}</div>

      <div className="status status--waiting"></div>
      {/*<div className="status status--ok"></div>*/}

      <div className="action">
        <button className="btn-cancel" onClick={handleCancel}></button>
        <button className="btn-ok" onClick={handleAccept}></button>
      </div>
    </Wrap>
  );
});

export default PopupWish;
